import { ButtonHTMLAttributes, FC } from 'react';

import { Icon } from '@/shared/ui';

import styles from './showMore.module.scss';

interface ShowMoreProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean;
}

const ShowMore: FC<ShowMoreProps> = (props) => {
  const { active, ...rest } = props;
  const text = active ? 'Свернуть' : 'Показать все';
  const iconName = active ? 'minusSmall' : 'plusSmall';

  return (
    <button {...rest} className={styles.button}>
      {text} <Icon name={iconName} />
    </button>
  );
};

export default ShowMore;
